var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._t("default"),_c('Lead',{staticClass:"project-lead",attrs:{"reference":{ onModel: 'Project', ref: _vm.item.id },"fields":['!title', '!comment', '!contact.upsell'],"action-label":"Send inn","placeholders":{
      'contact.name': 'Navn',
      'contact.email': 'E-post',
      'contact.phone': 'Telefon',
      'contact.company.organizationNumber': 'Org.nr',
      'contact.company.name': 'Bedriftsnavn'

    }}})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }